import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Injectable({
	providedIn: 'root',
})
export class LoadingIndicatorService {
	private spinnerTopRef: OverlayRef;

	constructor(private overlay: Overlay) {
		this.spinnerTopRef = this.cdkSpinnerCreate();
	}

	private cdkSpinnerCreate(): OverlayRef {
		return this.overlay.create({
			hasBackdrop: true,
			backdropClass: 'dark-backdrop',
			positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
		});
	}

	public showSpinner(): void {
		this.spinnerTopRef.attach(new ComponentPortal(MatProgressSpinner));
	}

	public stopSpinner(): void {
		this.spinnerTopRef.detach();
	}
}
